export const items = {
  Katana: "Broń ręczna, parowanie, szybki.",
  Wakizashi: "Broń ręczna, cios łaski, lekki, wyważony.",
  "Wachlarz bojowy": "Broń ręczna, łamacz, parująca, wspinaczka, wyważony.",
  Kropierz: "Wierzchowiec z zasadą Potwór otrzymuje +2 do Ochrony Pancerza (5+ bez pancerza), premię +1 do Siły trafień z uderzenia i zasadę Uderza jako ostatni.",
  Lekki: "Model odziany w LEKKI PANCERZ otrzymuje Ochronę Pancerza na 6+.",
  Średni: "Model odziany w ŚREDNI PANCERZ otrzymuje Ochronę Pancerza na 5+.",
  Ciężki: "Model odziany w CIĘŻKI PANCERZ otrzymuje Ochronę Pancerza na 4+.",
  Hełm: "Model, który chroni głowę hełmem otrzymuje rzut ochronny 4+ przeciwko efektom Powalenia na ziemię! Jeżeli rzut zakończy się sukcesem, postać należy traktować jako Oszołomioną!",
  Tarcza:
    "Model dzierżący TARCZĘ otrzymuje premię +1 do Ochrony Pancerza lub otrzymuje Ochronę Pancerza na 6+ jeśli nie posiada PANCERZA.",
  Puklerz: "Puklerz posiada cechę oręża PARUJĄCY.",
  "Pancerz z Gromrilu":
    "Model odziany w PANCERZ Z GROMRILU otrzymuje Ochronę Pancerza na 3+.",
  "Zbroja Chaosu":
    "Model odziany w Zbroję Chaosu otrzymuje Ochronę Pancerza na 3+. Zbroja Chaosu jest tak lekka, że nie powoduje modyfikatorów ujemnych do SZYBKOŚCI i INICJATYWY, związanych z noszeniem CIĘŻKIEGO PANCERZA. Co więcej, MAG używający tej zbroi  może rzucać zaklęcia.",
  Bicz: "Broń ręczna, szybki, uderza jako pierwszy.",
  Bosak: "Premia +1 do SIŁY, drzewcowa, uderza jako pierwszy, wymaga obu rąk.",
  "Broń wielka": "Premia +2 do SIŁY, uderza jako ostatni, wymaga obu rąk.",
  "Buława/Maczuga/Młot bojowy": "Broń ręczna, ogłuszający.",
  "Cep bojowy":
    "Premia +1 do SIŁY w pierwszej turze każdej walki wręcz, korbacz, przebicie pancerza, wymaga obu rąk.",
  Chopesz: "Broń ręczna, parujący, szybki.",
  Draich:
    "Premia +1 do SIŁY, limitowany (3), parujący, precyzyjne uderzenie, przebicie pancerza, wymaga obu rąk.",
  "Duża dźgacz":
    "Premia +2 do SIŁY w czasie szarży, drzewcowa, limitowany (1), uderza jako pierwszy.",
  "Gwiazda zaranna": "Broń ręczna, przebicie pancerza.",
  Halabarda: "Premia +1 do SIŁY, drzewcowa, wymaga obu rąk.",
  "Kadzielnica ognia":
    "Premia +1 do SIŁY, korbacz, limitowany (3), płonący atak, przebicie pancerza, wymaga obu rąk.",
  "Kadzielnica zarazy":
    "Premia +1 do SIŁY w pierwszej turze każdej walki wręcz, korbacz, limitowany (1), przebicie pancerza, siewca zarazy, wymaga obu rąk.",
  "Karwasz bojowy": "Broń ręczna, parująca, wyważony.",
  Khutar: "Broń ręczna, łamacz mieczy, parująca, wspinaczka, wyważony.",
  Kopia: "Premia +2 do SIŁY w czasie szarży, drzewcowa, uderza jako pierwszy.",
  Korbacz: "Korbacz, przebicie pancerza, szybki.",
  Kosa: "Premia +1 do SIŁY, szybki, uderza jako pierwszy, wymaga obu rąk.",
  Kostur: "Drzewcowa, ogłuszający, parujący, wymaga obu rąk.",
  "Kostur Rykowca":
    "Wymaga obu rąk oraz premia +2 do SIŁY, drzewcowa, uderza jako ostatni lub ogłuszający,  parujący, wymaga obu rąk, otrzymuje w czasie walki wręcz premię +2 do Ochrony Pancerza lub  otrzymuje Ochronę Pancerza na 5+ jeśli nie posiada PANCERZA. Ponadto, kostur rykowca jest  dostępny wyłącznie dla modeli Szamanów służących w Zbrojnych stadzie Zwierzoludzi.",
  "Łamacz mieczy": "Broń ręczna, łamacz mieczy, parujący, wyważony.",
  Łapacz:
    "Drzewcowa, limitowany (3), unieruchamiający, uderza jako ostatni, wymaga obu rąk.",
  "Maczuga ogrów": "Broń ręczna, ogłuszający, przebicie pancerza.",
  Miecz: "Broń ręczna, parujący.",
  "Młot ulrykański": "Premia +1 do SIŁY, przebicie pancerza, wymaga obu rąk.",
  Pika: "Premia +1 do SIŁY w pierwszej turze każdej walki wręcz, drzewcowa, uderza jako pierwszy.",
  Rapier: "Broń ręczna, lekki, parujący, precyzyjne uderzenie.",
  Rembak:
    "Premia +1 do SIŁY w pierwszej turze każdej walki wręcz, broń ręczna.",
  Saerath:
    "Broń ręczna, drzewcowa, limitowany (3), uderza jako pierwszy, wymaga obu rąk lub ogłuszający, parujący, wymaga obu rąk, otrzymuje w czasie walki wręcz premię +2 do Ochrony Pancerza lub otrzymuje Ochronę Pancerza na 5+ jeśli nie posiada PANCERZA.",
  Spaczhalabarda:
    "Premia +1 do SIŁY, druzgoczący, drzewcowa, eksperymentalny, limitowany (3), przebicie pancerza, wymaga obu rąk.",
  Spaczkhutar:
    "Premia +1 do SIŁY, broń ręczna, limitowany (3), łamacz mieczy, parująca, wspinaczka, wyważony, zatruty atak.",
  Sztylet: "Broń ręczna, lekki, nie zadaje zranień krytycznych.",
  "Topór bojowy/Nadziak": "Broń ręczna, przebicie pancerza.",
  "Topór z Chrace":
    "Premia +2 do SIŁY, druzgoczący, limitowany (3), uderza jako ostatni, wymaga obu rąk.",
  "Topór krasnoludów": "Broń ręczna, parujący, przebicie pancerza.",
  Trójząb:
    "Drzewcowa, łamacz mieczy, parujący, uderza jako pierwszy, wymaga obu rąk.",
  Arkan:
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: - ; ZASADY: limitowany (3), unieruchamiający.",
  Bolas:
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: - ; ZASADY: limitowany (3), unieruchamiający.",
  Sieć: "MAKSYMALNY ZASIĘG: 8”; SIŁA: - ; ZASADY: limitowany (3), unieruchamiający.",
  "Broń miotana (noże)":
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: użytkownika; ZASADY: broń miotana.",
  "Broń miotana (młoty/topory)":
    "MAKSYMALNY ZASIĘG: 6”; SIŁA: użytkownika +1; ZASADY: broń miotana.",
  Dmuchawka:
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: 3; ZASADY: broń miotana, przebicie pancerza, skrytobójczy, zatruty atak; nie zadaje zranień krytycznych.",
  Harpun:
    "MAKSYMALNY ZASIĘG: 16”; SIŁA: 5; ZASADY: limitowany (1), przebicie pancerza, 2x - wymaga przygotowania, wymaga obu rąk.",
  "Kula trującego wichru":
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: - ; ZASADY: broń miotana, limitowany (1).",
  Kusza:
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: 4; ZASADY: przebicie pancerza, ruch albo strzał, wymaga obu rąk.",
  "Kusza powtarzalna":
    "MAKSYMALNY ZASIĘG: 18”; SIŁA: 3; ZASADY: 2x - wielokrotny strzał, przebicie pancerza, wymaga obu rąk.",
  "Łuk długi": "MAKSYMALNY ZASIĘG: 24”; SIŁA: 3; ZASADY: wymaga obu rąk.",
  "Łuk elfów":
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: 3/4; ZASADY: przebicie pancerza, wymaga obu rąk.",
  "Łuk krótki": "MAKSYMALNY ZASIĘG: 12”; SIŁA: 3; ZASADY: wymaga obu rąk.",
  Łuk: "MAKSYMALNY ZASIĘG: 18”; SIŁA: 3; ZASADY: wymaga obu rąk.",
  Oszczep: "MAKSYMALNY ZASIĘG: 12”; SIŁA: użytkownika; ZASADY: broń miotana.",
  "Pistolet strzałkowy":
    "MAKSYMALNY ZASIĘG: 10”; SIŁA: 4; ZASADY: bezpośredni strzał; może zawsze stać & strzelać.",
  "Pistolet strzałkowy powtarzalny":
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: 3; ZASADY: 2x - wielokrotny strzał, może zawsze stać & strzelać.",
  Proca:
    "MAKSYMALNY ZASIĘG: 12”; SIŁA: 3; ZASADY: 2x - wielokrotny strzał we wroga w zasięgu 6”.",
  "Wnyk łańcuchowy":
    "MAKSYMALNY ZASIĘG: 10”; SIŁA: K6; ZASADY: limitowany (1), przebicie pancerza.",
  Arkebuz:
    "MAKSYMALNY ZASIĘG: 48”; SIŁA: 5; ZASADY: limitowany (1), przebicie pancerza, ruch albo strzał, wymaga forkietu, wymaga obu rąk, wymaga przygotowania, zawodny.",
  "Broń miotana (ładunki wybuchowe)":
    "MAKSYMALNY ZASIĘG: 6”; SIŁA: K6; ZASADY: broń miotana, płonący atak, zawodny.",
  Falkonet:
    "MAKSYMALNY ZASIĘG: wzornik płomienia; SIŁA: 4; ZASADY: limitowany (1), odłamkowy,  przebicie pancerza, ruch albo strzał, wymaga forkietu, wymaga obu rąk, 3x – wymaga, przygotowania, zawodny.",
  Garłacz:
    "MAKSYMALNY ZASIĘG: wzornik płomienia; SIŁA: 3; ZASADY: limitowany (3), odłamkowy, ruch albo strzał, wymaga obu rąk, 2x – wymaga przygotowania, zawodny.",
  "Gołąb bombardujący":
    "MAKSYMALNY ZASIĘG: 16”; SIŁA: K6; ZASADY: limitowany (3), płonący atak, ruch albo strzał, zawodny.",
  "Granat dymny": "MAKSYMALNY ZASIĘG: 8”; SIŁA: - ; ZASADY: broń miotana.",
  Granatnik:
    "MAKSYMALNY ZASIĘG: 16”; SIŁA: 6; ZASADY: limitowany (1), przebicie pancerza, ruch albo strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  Kulomiot:
    "MAKSYMALNY ZASIĘG: wzornik płomienia; SIŁA: K6; ZASADY: eksperymentalny, limitowany (1), przebicie pancerza.",
  "Miotacz spaczognia":
    "MAKSYMALNY ZASIĘG: Kostka Artyleryjska; SIŁA: K6 (OBRAŻENIA: K3); ZASADY: limitowany (1), płonący atak, przebicie pancerza.",
  "Moździerz trującego wichru":
    "MAKSYMALNY ZASIĘG: 8” - 36”; SIŁA: -; ZASADY: limitowany (1).",
  Muszkiet:
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: 4; ZASADY: przebicie pancerza, ruch albo strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  "Muszkiet dubeltowy":
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: 4; ZASADY: limitowany (3), przebicie pancerza, ruch albo strzał, 2x – wielokrotny strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  "Muszkiet hochlandzki":
    "MAKSYMALNY ZASIĘG: 36”; SIŁA: 4; ZASADY: limitowany (1), przebicie pancerza, ruch albo strzał, strzelec wyborowy, wymaga obu rąk, wymaga przygotowania, zawodny.",
  "Muszkiet krasnoludzki":
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: 4; ZASADY: mistrzowskie wykonanie, przebicie pancerza, ruch albo strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  Ołowiomiotacz:
    "MAKSYMALNY ZASIĘG: wzornik płomienia; SIŁA: 4; ZASADY: limitowany (1), przebicie pancerza, wymaga obu rąk, 3x – wymaga przygotowania.",
  Pistolet:
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: 4; ZASADY: bezpośredni strzał, może zawsze stać & strzelać, przebicie pancerza, wymaga przygotowania, zawodny.",
  "Pistolet dubeltowy":
    "MAKSYMALNY ZASIĘG: 8”; SIŁA: 4; ZASADY: bezpośredni strzał, może zawsze stać & strzelać, limitowany (4), przebicie pancerza, wymaga przygotowania, zawodny, 2x – wielokrotny strzał.",
  "Pistolet pojedynkowy":
    "MAKSYMALNY ZASIĘG: 12”; SIŁA: 4; ZASADY: bezpośredni strzał, limitowany (4), mistrzowskie wykonanie, może zawsze stać & strzelać, przebicie pancerza, wymaga przygotowania, zawodny.",
  Revolvera:
    "MAKSYMALNY ZASIĘG: 18”; SIŁA: 4; ZASADY: limitowany (1), ruch albo strzał, 6x – wielokrotny strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  Spaczmuszkiet:
    "MAKSYMALNY ZASIĘG: 24”; SIŁA: K6; ZASADY: eksperymentalny, przebicie pancerza, ruch albo strzał, wymaga obu rąk, wymaga przygotowania, zawodny.",
  Spaczpistolet:
    "MAKSYMALNY ZASIĘG: 8+K6”; SIŁA: K6; ZASADY: bezpośredni strzał, eksperymentalny, limitowany (4), może zawsze stać & strzelać, przebicie pancerza, wymaga przygotowania, zawodny.",
  Spaczrusznica:
    "MAKSYMALNY ZASIĘG: 48”; SIŁA: K6; ZASADY: eksperymentalny, limitowany (1), strzelec wyborowy, wymaga forkietu, wymaga obu rąk, zawodny.",
};
